// eslint-disable-next-line import/prefer-default-export
export const GIFT_SKU_PARAM_KEY = 'sku'
